import OnboardingPage from "@src/pages/wedding-invitation/Onboarding";
import { lazy } from "react";
const WeddingInvitationMain = lazy(() => import("../pages/wedding-invitation/main/Main"));
const WeddingInvitationManage = lazy(() => import("../pages/wedding-invitation/manage/Manage"));
const WithdrawHistory = lazy(() => import("../pages/wedding-invitation/manage/WithdrawHistory"));
const FundingWithdraw = lazy(() => import("../pages/wedding-invitation/manage/Withdraw"));
const WithdrawComplete = lazy(() => import("../pages/wedding-invitation/manage/WithdrawComplete"));
const FundingExchange = lazy(() => import("../pages/wedding-invitation/manage/Exchange"));
const ExchangeComplete = lazy(() => import("../pages/wedding-invitation/manage/ExchangeComplete"));
const WeddingInvitationWrite = lazy(() => import("../pages/wedding-invitation/write/Write"));
const RsvpUpdatePage = lazy(() => import("../pages/wedding-invitation/rsvp/update/RsvpUpdate"));

export const weddingInvitationRoutes = [
  { path: "/wedding-invitation", element: <WeddingInvitationMain /> },
  { path: "/wedding-invitation/manage", element: <WeddingInvitationManage /> },
  { path: "/wedding-invitation/withdraw-history", element: <WithdrawHistory /> },
  { path: "/wedding-invitation/withdraw", element: <FundingWithdraw /> },
  { path: "/wedding-invitation/exchange", element: <FundingExchange /> },
  { path: "/wedding-invitation/withdraw-complete", element: <WithdrawComplete /> },
  { path: "/wedding-invitation/exchange-complete", element: <ExchangeComplete /> },
  { path: "/wedding-invitation/write", element: <WeddingInvitationWrite /> },
  { path: "/wedding-invitation/onboarding", element: <OnboardingPage /> },
  { path: "/wedding-invitation/rsvp/update", element: <RsvpUpdatePage /> },
];
